<admin-app-header></admin-app-header>
<div class="container-fluid admyt-page">
    <!-- Header with navigation -->
    <div class="row my-3">
        <div class="col-md-8">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/admin/admyt-centers']">Admyt Centers</a>
                    </li>
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/admin/admyt-center', centerId]">{{ truncate(centerId, 12) }}</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{ tenant?.name || tenantId }}
                    </li>
                </ol>
            </nav>
        </div>
        <div class="col-md-4 text-end">
            <button class="admyt-btn-secondary" (click)="refreshData()" [disabled]="loading">
                <i class="fa-solid fa-refresh" [class.fa-spin]="loading"></i> Refresh
            </button>
        </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="text-center my-5">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="mt-2">Loading tenant details...</p>
    </div>

    <!-- Error state -->
    <div *ngIf="error" class="alert alert-danger">
        {{ error }}
        <button (click)="refreshData()" class="btn btn-outline-danger btn-sm ms-2">Try Again</button>
    </div>

    <!-- Tenant details -->
    <div *ngIf="!loading && !error && tenant">
        <!-- Stat Cards -->
        <div class="admyt-stat-cards">
            <div class="admyt-stat-card admyt-stat-card--purple">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-id-card"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Tenant</span>
                    <span class="admyt-stat-card__value">{{ tenant.name.split(' ').slice(0, 2).join(' ') }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--blue">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-users"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Tenant Users</span>
                    <span class="admyt-stat-card__value">{{ tenantUsers.length }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--teal">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-square-parking"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Bays Allocated</span>
                    <span class="admyt-stat-card__value">{{ tenant.baysNumber || 0 }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--green" *ngIf="getSubscriptionId()">
                <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i> ParkUpp</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-file-signature"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Linked Subscription</span>
                    <a [routerLink]="['/admin/subscription', getSubscriptionId()]" class="admyt-link">
                        {{ truncate(getSubscriptionId(), 10) }}
                    </a>
                </div>
            </div>
        </div>

        <!-- Tenant Information Card -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h3>
                    <i class="fa-solid fa-id-card me-2"></i>
                    Tenant Details
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h3>
                <div class="d-flex gap-2">
                    <a *ngIf="getSubscriptionId()" [routerLink]="['/admin/subscription', getSubscriptionId()]" class="admyt-btn-primary">
                        <i class="fa-solid fa-file-signature"></i> View Subscription
                    </a>
                    <button
                        class="btn btn-danger"
                        (click)="deactivateTenant()"
                        [disabled]="deactivating || tenant.status === 'inactive'"
                    >
                        <i class="fa fa-spinner fa-spin" *ngIf="deactivating"></i>
                        <i class="fa-solid fa-ban" *ngIf="!deactivating"></i>
                        {{ deactivating ? 'Deactivating...' : 'Deactivate Tenant' }}
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <dl class="row mb-0">
                        <dt class="col-sm-4">Tenant ID:</dt>
                        <dd class="col-sm-8">
                            <code>{{ tenant.id }}</code>
                        </dd>

                        <dt class="col-sm-4">Name:</dt>
                        <dd class="col-sm-8">
                            <strong>{{ tenant.name }}</strong>
                        </dd>

                        <dt class="col-sm-4">Center:</dt>
                        <dd class="col-sm-8">
                            <a [routerLink]="['/admin/admyt-center', centerId]" class="admyt-link">
                                <i class="fa-solid fa-building"></i> {{ truncate(centerId, 12) }}
                            </a>
                        </dd>

                        <dt class="col-sm-4" *ngIf="tenant.baysNumber">Bays:</dt>
                        <dd class="col-sm-8" *ngIf="tenant.baysNumber">
                            <span class="admyt-status admyt-status--active">{{ tenant.baysNumber }} bays</span>
                        </dd>
                    </dl>
                </div>
                <div class="col-md-6">
                    <dl class="row mb-0">
                        <dt class="col-sm-4" *ngIf="tenant.status">Status:</dt>
                        <dd class="col-sm-8" *ngIf="tenant.status">
                            <span [class]="getStatusClass(tenant.status)">
                                {{ tenant.status }}
                            </span>
                        </dd>

                        <dt class="col-sm-4" *ngIf="tenant.zones && tenant.zones.length > 0">Zones:</dt>
                        <dd class="col-sm-8" *ngIf="tenant.zones && tenant.zones.length > 0">
                            <span *ngFor="let zone of tenant.zones" class="admyt-status admyt-status--active me-1">
                                {{ zone }}
                            </span>
                        </dd>

                        <dt class="col-sm-4" *ngIf="getSubscriptionId()">Subscription:</dt>
                        <dd class="col-sm-8" *ngIf="getSubscriptionId()">
                            <a [routerLink]="['/admin/subscription', getSubscriptionId()]" class="admyt-link">
                                <i class="fa-solid fa-arrow-up-right-from-square"></i> {{ getSubscriptionId() }}
                            </a>
                            <span class="data-source data-source--parkupp ms-2"><i class="fa-solid fa-database"></i> ParkUpp</span>
                        </dd>
                    </dl>
                </div>
            </div>
            <div *ngIf="tenant.status === 'inactive'" class="alert alert-warning mt-3 mb-0">
                <i class="fa-solid fa-exclamation-triangle"></i> This tenant is inactive. Users cannot access parking.
            </div>
        </div>

        <!-- Tenant Users -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h4>
                    <i class="fa-solid fa-users me-2"></i>
                    Tenant Users
                    <span class="admyt-status admyt-status--active ms-2">{{ tenantUsers.length }}</span>
                    <span class="data-source data-source--admyt ms-2"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h4>
            </div>

            <!-- Users loading state -->
            <div *ngIf="usersLoading" class="text-center py-4">
                <i class="fa fa-spinner fa-spin"></i>
                Loading users...
            </div>

            <!-- No users message -->
            <div *ngIf="!usersLoading && tenantUsers.length === 0" class="text-center py-5">
                <i class="fa-solid fa-users fa-2x text-muted"></i>
                <p class="mt-2 text-muted">No users are currently registered for this tenant.</p>
            </div>

            <!-- Users table -->
            <div *ngIf="!usersLoading && tenantUsers.length > 0" class="table-responsive">
                <table class="admyt-table">
                    <thead>
                        <tr>
                            <th>User ID <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i></span></th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>ParkUpp User <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i></span></th>
                            <th>Status</th>
                            <th>Cars</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of tenantUsers">
                            <td>
                                <code>{{ truncate(user.id, 12) }}</code>
                            </td>
                            <td>
                                <strong>{{ user.firstName }} {{ user.lastName }}</strong>
                            </td>
                            <td>
                                {{ user.email }}
                            </td>
                            <td>
                                <ng-container *ngIf="getLinkedUser(user.email) as linkedUser">
                                    <a [routerLink]="['/admin/client', linkedUser.uid]" class="admyt-link">
                                        <i class="fa-solid fa-user"></i>
                                        {{ linkedUser.firstName }} {{ linkedUser.lastName }}
                                    </a>
                                </ng-container>
                                <span *ngIf="!getLinkedUser(user.email)" class="text-muted">
                                    <i class="fa-solid fa-unlink"></i> Not linked
                                </span>
                            </td>
                            <td>
                                <span *ngIf="user.status" [class]="getStatusClass(user.status)">
                                    {{ user.status }}
                                </span>
                                <span *ngIf="!user.status" class="text-muted">N/A</span>
                            </td>
                            <td>
                                <span *ngIf="user.cars && user.cars.length > 0" class="admyt-status admyt-status--active">
                                    {{ user.cars.length }} car(s)
                                </span>
                                <span *ngIf="!user.cars || user.cars.length === 0" class="text-muted">No cars</span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <a class="btn btn-outline-primary btn-sm" [routerLink]="['/admin/admyt-user', user.id]" title="View Admyt user">
                                        <i class="fa-solid fa-eye"></i>
                                    </a>
                                    <a *ngIf="getLinkedUser(user.email)" class="btn btn-outline-secondary btn-sm" [routerLink]="['/admin/client', getLinkedUser(user.email)?.uid]" title="View ParkUpp profile">
                                        <i class="fa-solid fa-user"></i>
                                    </a>
                                    <button class="btn btn-outline-danger btn-sm" title="Delete user" (click)="deleteUser(user.id)">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
